import { render, staticRenderFns } from "./CharakterSjDialog.vue?vue&type=template&id=ce3c94ae&"
import script from "./CharakterSjDialog.vue?vue&type=script&lang=ts&"
export * from "./CharakterSjDialog.vue?vue&type=script&lang=ts&"
import style0 from "./CharakterSjDialog.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports